import * as R from 'ramda'

// > [ [ key: 'a',  value: 1 ], [ key: 'b', value: 2 ] ]
// < { a: 1, b: 2 }
export const collection_to_object = R.reduce(
    (obj, field) => R.assoc(field.key, field.value, obj), {}
)

export const object_to_collection = R.compose(

    // Aus Paare Objekte erstellen
    // > [ [ 'a', 1 ], [ 'b', 2 ] ]
    // < [ [ key: 'a',  value: 1 ], [ key: 'b', value: 2 ] ]
    R.map(([key, value]) => ({ key, value })),

    // Properties in Paare (`key`, `value`) splitten
    // > { a: 1, b: 2 }
    // < [ [ 'a', 1 ], [ 'b', 2 ] ]
    R.toPairs

)
